const PHOTON_API_URL = 'https://photon.komoot.io/api/'

const getCoordinates = feature => feature?.geometry?.coordinates || []

export const normalizePhotonFeature = (feature) => {
  const properties = feature?.properties || {}
  const [lon, lat] = getCoordinates(feature)

  return {
    place_id: `${properties.osm_type || 'place'}-${properties.osm_id || `${lon}-${lat}`}`,
    lat: lat != null ? String(lat) : '',
    lon: lon != null ? String(lon) : '',
    display_name: [
      [properties.street || properties.name, properties.housenumber].filter(Boolean).join(' '),
      [properties.postcode, properties.city || properties.town || properties.village].filter(Boolean).join(' '),
      properties.country
    ].filter(Boolean).join(', '),
    address: {
      road: properties.street || properties.name || '',
      house_number: properties.housenumber || '',
      postcode: properties.postcode || '',
      city: properties.city || '',
      town: properties.town || '',
      village: properties.village || '',
      municipality: properties.district || properties.county || '',
      country: properties.country || 'Deutschland',
      country_code: String(properties.countrycode || '').toLowerCase()
    }
  }
}

export const searchPhotonAddresses = async (query, limit = 5) => {
  const params = new URLSearchParams({
    q: String(query || '').trim(),
    lang: 'de',
    limit: String(limit)
  })
  const response = await fetch(`${PHOTON_API_URL}?${params.toString()}`)

  if (!response.ok) {
    throw new Error(`Photon-Anfrage fehlgeschlagen (${response.status})`)
  }

  const data = await response.json()

  return (data?.features || [])
      .filter(feature => {
        const countryCode = String(feature?.properties?.countrycode || '').toLowerCase()
        return !countryCode || countryCode === 'de'
      })
      .map(normalizePhotonFeature)
}
